import api from '../api';
import {
  AdoptionPost,
  AdoptionPostDetail,
  AdoptionInterest,
  AdoptionReport,
  AdoptionStats,
  PaginatedAdoptionPosts,
  PaginatedAdoptionInterests,
  PaginatedAdoptionReports,
} from '../../types/entities/adoption.types';

export const adoptionService = {
  // Get all adoption posts
  getAdoptionPosts: async (
    page: number = 1,
    limit: number = 50,
    status?: string
  ): Promise<PaginatedAdoptionPosts> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(status && { status }),
    });
    const response = await api.get(`/admin/adoptions?${params}`);
    return response.data;
  },

  // Get single adoption post with details
  getAdoptionPost: async (id: string): Promise<AdoptionPostDetail> => {
    const response = await api.get(`/admin/adoptions/${id}`);
    return response.data;
  },

  // Get all adoption interests
  getAllInterests: async (
    page: number = 1,
    limit: number = 50
  ): Promise<PaginatedAdoptionInterests> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    const response = await api.get(`/admin/adoptions/interests/all?${params}`);
    return response.data;
  },

  // Get all reports
  getAllReports: async (
    page: number = 1,
    limit: number = 50,
    status?: string
  ): Promise<PaginatedAdoptionReports> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(status && { status }),
    });
    const response = await api.get(`/admin/adoptions/reports/all?${params}`);
    return response.data;
  },

  // Update post status
  updatePostStatus: async (
    id: string,
    status: 'ACTIVE' | 'ADOPTED' | 'REMOVED'
  ): Promise<AdoptionPost> => {
    const response = await api.put(`/admin/adoptions/${id}/status`, { status });
    return response.data;
  },

  // Update report status
  updateReportStatus: async (
    id: string,
    status: 'PENDING' | 'REVIEWED' | 'RESOLVED',
    reviewedBy?: string
  ): Promise<AdoptionReport> => {
    const response = await api.put(`/admin/adoptions/reports/${id}`, {
      status,
      reviewedBy,
    });
    return response.data;
  },

  // Delete adoption post
  deletePost: async (id: string): Promise<void> => {
    await api.delete(`/admin/adoptions/${id}`);
  },

  // Get adoption statistics
  getStats: async (): Promise<AdoptionStats> => {
    const response = await api.get('/admin/adoptions/stats/overview');
    return response.data;
  },
};
